document.addEventListener('DOMContentLoaded', function () {
  const hamburger = document.getElementById('nav-hamburger');
  const mobileMenu = document.getElementById('nav-mobile-menu');
  const contactDrawer = document.getElementById('nav-contact-drawer');
  const drawerClose = document.getElementById('drawer-close');
  const drawerOverlay = document.getElementById('drawer-overlay');
  const currentPath = window.location.pathname;

  // ── Hamburger ──
  if (hamburger) {
    hamburger.addEventListener('click', function () {
      if (window.innerWidth > 768) {
        if (contactDrawer) contactDrawer.classList.toggle('open');
        if (drawerOverlay) drawerOverlay.classList.toggle('open');
      } else {
        if (mobileMenu) mobileMenu.classList.toggle('open');
      }
    });
  }

  // ── Drawer Close (X button) ──
  if (drawerClose) {
    drawerClose.addEventListener('click', function () {
      contactDrawer.classList.remove('open');
      drawerOverlay.classList.remove('open');
    });
  }

  // ── Overlay Click ──
  if (drawerOverlay) {
    drawerOverlay.addEventListener('click', function () {
      contactDrawer.classList.remove('open');
      drawerOverlay.classList.remove('open');
    });
  }

  // ── Active Nav Link (Desktop + Mobile) ──
  const allNavLinks = document.querySelectorAll('.nav-links a, .nav-mobile-menu a');
  allNavLinks.forEach(link => {
    link.classList.remove('active');
    if (link.getAttribute('href') === currentPath) {
      link.classList.add('active');
    }
  });

  // ── Products Dropdown Active Detection ──
  const productDropdownLinks = document.querySelectorAll('.nav-dropdown a, .mobile-dropdown-list a');
  const productsNavItem = document.querySelector('.nav-item.has-dropdown > .nav-link');
  const mobileProductsHeader = document.querySelector('.mobile-dropdown-header a');

  productDropdownLinks.forEach(link => {
    if (currentPath.startsWith(link.getAttribute('href'))) {
      if (productsNavItem) productsNavItem.classList.add('active');
      if (mobileProductsHeader) mobileProductsHeader.classList.add('active');
    }
  });
});

// ── Mobile Products Dropdown Toggle ──
const mobileDropdownIcon = document.querySelector('.mobile-dropdown-icon');
const mobileDropdownWrap = document.querySelector('.mobile-dropdown-wrap');

if (mobileDropdownIcon && mobileDropdownWrap) {
  mobileDropdownIcon.addEventListener('click', function () {
    mobileDropdownWrap.classList.toggle('open');
  });
}
